import axios from "../axiosInstance";

const AuthAPI = {
  login: (payload) => axios.post("admin/auth/login", payload),
  forgotPassword: (payload) => axios.post("admin/auth/forgot-password", payload),
  resetPasswordToken: (payload) => axios.post("admin/auth/verify-reset-token", payload),
  resetPassword: (payload) => axios.post("admin/auth/reset-password", payload),

  // token required wale endpoints
  getProfile: () => axios.get("admin/auth/my-profile"),
  updateProfile: (payload) => axios.post("admin/auth/update-profile", payload),
  updatePassword: (payload) => axios.post("admin/auth/update-password", payload),

  updateStatus: (payload) => axios.post("admin/auth/update-status", payload),
  delete: (payload) => axios.post("admin/auth/delete", payload),
};

export default AuthAPI;
